import { atom } from 'recoil'
import { IParameterGroup } from '@/pages/Parameters/parameters.types.ts'

interface IParameterGroupsState {
  items: IParameterGroup[]
  loaded: boolean
}

const parameterGroupsAtom = atom<IParameterGroupsState>({
  key: 'parameterGroups',
  default: {
    items: [],
    loaded: false,
  },
})

export default parameterGroupsAtom
